import { Helmet } from '@plone/volto/helpers';

/*
  -------------------------------------------------------------------
  Anti-flash do alto contraste
  -------------------------------------------------------------------
  A preferência mora em `localStorage` (ver `hooks/useAccessibility.js`),
  então o servidor não tem como conhecê-la: o HTML do SSR sai sempre no
  tema claro. Como a classe `mpf-contrast` só era aplicada no `useEffect`,
  depois da hidratação, quem usa alto contraste via a página piscar clara
  a cada navegação dura.

  Este script roda de forma síncrona no `<head>` — o Helmet o emite em
  `head.script.toComponent()`, que no `Html.jsx` do core vem antes de
  `head.style.toComponent()` —, então a classe já está no `<html>` antes
  do primeiro paint.

  Não é SSR de verdade (o HTML enviado continua sendo o claro); é
  correção de FOUC. O `try/catch` é obrigatório: em janela anônima ou com
  cookies bloqueados o acesso a `localStorage` lança, e uma exceção aqui
  travaria o parser antes de qualquer conteúdo aparecer.
  -------------------------------------------------------------------
*/

// Mantido em sincronia com CONTRAST_KEY/CONTRAST_CLASS de useAccessibility.js.
const BOOT = `(function(){try{var d=document.documentElement;
if(localStorage.getItem('mpf-a11y-contrast')==='1'){d.classList.add('mpf-contrast');}
var f=parseInt(localStorage.getItem('mpf-a11y-font')||'0',10)||0;
if(f){f=Math.min(3,Math.max(-2,f));d.style.setProperty('--base-font-size',(16+f*2)+'px');}
}catch(e){}})();`;

const ContrastBootScript = () => (
  <Helmet>
    <script type="text/javascript">{BOOT}</script>
  </Helmet>
);

export default ContrastBootScript;
